
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/join",
      function () {
        return require("private-next-pages/join/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/join"])
      });
    }
  